import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getRandomColor } from '../../utils/colors';
import { useRandomLinkColors } from '../../utils/useRandomLinkColors';
const Header = () => {
  // Use our custom hook
  const isMobile = useRandomLinkColors();
  // Apply random colors to header links immediately
  useEffect(() => {
    const headerLinks = document.querySelectorAll('header a');
    headerLinks.forEach(link => {
      // Always apply a random color on initial render, regardless of data-color-applied attribute
      link.style.color = getRandomColor();
      link.dataset.colorApplied = 'true';
    });
  }, []);
  return <header className="fixed top-0 w-full flex justify-end px-6 py-6 z-10 bg-[#faf9f7]" data-id="element-638">
      <div className="flex space-x-6" data-id="element-639">
        <div className="text-base font-normal" data-id="element-640">
          <Link to="/" className="transition-colors duration-200"
        // Apply random color directly in the JSX
        style={{
          color: getRandomColor()
        }} data-color-applied="true" data-id="element-641">
            Madeleine Morlet
          </Link>
        </div>
        <div className="text-base font-normal" data-id="element-642">
          <Link to="/info" className="transition-colors duration-200"
        // Apply random color directly in the JSX
        style={{
          color: getRandomColor()
        }} data-color-applied="true" data-id="element-643">
            Info
          </Link>
        </div>
      </div>
    </header>;
};
export default Header;